import {
  NavigateEditPageButton,
  NotFound,
  PageContent,
  PageHeader,
  Space,
} from '@/components';
import { TenantManagerResourceGuard } from '@/features/authentication/_components/TenantManagerResourceGuard';
import { useCreateBreadcrumbs } from '@/hooks/creaet-breadcrumbs';
import { useTranslation } from 'react-i18next';
import { Route, Routes } from 'react-router';
import { NavigationLabelButton } from '../organization/_components/NavigationLabelButton';
import { RoleActionsButton } from './_components/RoleActionsButton';
import { CreateRolePage } from './_pages/CreateRolePage';
import { RoleDetailsPage } from './_pages/RoleDetailsPage';
import { RolesPage } from './_pages/RolesPage';
import { UpdateRolePage } from './_pages/UpdateRolePage';

export const RolesRoutes = () => {
  const { t } = useTranslation();
  const { createBreadcrumb } = useCreateBreadcrumbs({ baseIndex: 3 });

  return (
    <Routes>
      <Route
        path="*"
        element={<NotFound showBackButton={false} height="100vh" />}
      />
      <Route
        index
        element={
          <>
            <PageHeader
              title={t('tenant-manager-root-page')}
              breadcrumbs={createBreadcrumb([
                { title: t('tenant-manager-root-page') },
              ])}
              buttons={<NavigationLabelButton />}
            />
            <PageContent>
              <RolesPage />
            </PageContent>
          </>
        }
      />
      <Route
        path="/new"
        element={
          <TenantManagerResourceGuard onlyEdit showDenied>
            <PageHeader
              title={t('create-role-page')}
              breadcrumbs={createBreadcrumb([
                { title: t('tenant-manager-root-page') },
                { title: t('create-role-page') },
              ])}
            />
            <PageContent>
              <CreateRolePage />
            </PageContent>
          </TenantManagerResourceGuard>
        }
      />
      <Route
        path="/:id"
        element={
          <>
            <PageHeader
              title={t('role-details-page')}
              breadcrumbs={createBreadcrumb([
                { title: t('tenant-manager-root-page') },
                { title: t('role-details-page') },
              ])}
              buttons={
                <TenantManagerResourceGuard onlyEdit>
                  <Space>
                    <NavigateEditPageButton />
                    <RoleActionsButton />
                  </Space>
                </TenantManagerResourceGuard>
              }
            />
            <PageContent>
              <RoleDetailsPage />
            </PageContent>
          </>
        }
      />
      <Route
        path="/:id/edit"
        element={
          <TenantManagerResourceGuard onlyEdit showDenied>
            <PageHeader
              title={t('update-role-page')}
              breadcrumbs={createBreadcrumb([
                { title: t('tenant-manager-root-page') },
                { title: t('role-details-page') },
                { title: t('update-role-page') },
              ])}
            />
            <PageContent>
              <UpdateRolePage />
            </PageContent>
          </TenantManagerResourceGuard>
        }
      />
    </Routes>
  );
};
